module.exports = __webpack_public_path__ + "static/media/disinfecting-with-h2o2-onsite-drapery-cleaning.e1e97fc8.pdf";